var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCyberSec(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M762.1 944.8l-660-230v-552l660 192z",
    fill: "#37BBEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M762.1 944.8l160-170v-550l-160 130z",
    fill: "#2481BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.1 162.8l660 192 160-130L297.7 68.2z",
    fill: "#3ED6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M922.1 399.4v-25.7l-160 129.7v2.7l-244.3-74.8V297.6h-20v127.6l-262-80.2V210.7h-20v128.1L102.1 304v20.9l233.7 71.5v112l-233.7-74.9v21l113.7 36.4v121.9l-113.7-36.4v21l233.7 74.9v123.9l20 7V678.8l280 89.7v132.3l20 7V774.9L762.1 809v2.3l160-153.8v-28.6l-160 153.8v5.3l-244.3-78.3V587.8l244.3 78.3v1.4l160-141.8v-27.1l-160 141.8v4.8l-106.3-34.1V494.4L762.1 527v2.1l160-129.7zM497.8 703.3l-262-84V497.5l262 84v121.8z m138-98.6l-280-89.7V402.6l280 85.7v116.4z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1 637.5s27.9-8 39.9-64 22-126 22-126 38 134 72 160c32.4 24.8 26-52 80-102s111-34 117-34-138.6 105.7-42 174c58 41 86-26 126-74s54-25 54-25-18 147 18 143 78-90 78-90 61 91 83 201 12.1 171.3 12.1 171.3l-660-233V637.5z",
    fill: "#69FFF7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1 157.8l695.6 195.6 189.6-129.2-667.6-172z",
    fill: "#3ED6FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7 179.2v-21.4l697 195.6v24.8z",
    fill: "#369BCE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M955.3 224.2V248L765.7 378.2v-24.8z",
    fill: "#1A6D96"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberSec);
export default __webpack_public_path__ + "static/media/CyberSec.821236f65418b06c40df03a20dd65270.svg";
export { ForwardRef as ReactComponent };